import { useQuery } from '@tanstack/react-query';

import { RemoteCommanListAPI } from './models/RemoteCommandApi';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export const getInspectionCommandeStatus = async (
  makeRequest: any,
  {
    ticketId,
    lpUi,
  }: {
    ticketId: string;
    lpUi: string;
  }
): Promise<RemoteCommanListAPI> => {
  const { error, data } = await makeRequest({
    path: `/inspection/tickets/${ticketId}/products/${lpUi}/remote-commands`,
  });
  if (error) {
    throw new Error(error);
  }

  return data;
};

type QueryFnType = typeof getInspectionCommandeStatus;

type UseGetInspectionCommandeStatusOptions = {
  ticketId: string;
  lpUi: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetInspectionCommandeStatus = ({
  ticketId,
  lpUi,
  config,
}: UseGetInspectionCommandeStatusOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getInspectionCommandeStatus', ticketId, lpUi],
    queryFn: () => getInspectionCommandeStatus(makeRequest, { ticketId, lpUi }),
  });
};
